<template>
  <div class="content-bg--2 fill-height">
    <v-layout
      :column="!isMobile"
      justify-space-between
      ma-0
      class="text-sm-center pb-sm-5 pa-sm-4 fill-height"
    >
      <button
        v-if="!isMobile"
        @click="delTheme"
        class="link align-self-end"
        icon
      >
        <icon-close></icon-close>
      </button>
      <v-layout
        class="display-1 font-weight-bold pb-2 px-4"
        :class="
          isMobile
            ? 'justify-space-between align-self-center flex order-xs2 sm9 xs10'
            : 'justify-center'
        "
      >
        <div>
          {{ theme.name }}
          <div class="text--secondary subtitle-1 mt-2">
            <span v-if="hotspotList && hotspotList.length">
              {{ hotspotNames }}
            </span>
            <span v-else>Хот-спот не выбран</span>
          </div>
        </div>
        <button
          v-if="isMobile"
          @click="openDialog"
          class="link align-self-start"
        >
          <icon-dots></icon-dots>
        </button>
      </v-layout>

      <theme-preview-xs
        :themeId="theme.id"
        class="py-0 py-sm-4 px-0 px-sm-2 flex sm3 xs2 order-xs1"
        :type="isMobile ? 'onlyMobile' : 'xs'"
      ></theme-preview-xs>
      <div v-if="!isMobile" class="flex order-xs3 shrink">
        <v-btn
          :to="{ name: 'themeSettings', params: { id: theme.id } }"
          class="primary"
        >
          Изменить
        </v-btn>
        <v-btn @click="copyTheme" class="primary" outline>Дублировать</v-btn>
      </div>
    </v-layout>

    <v-dialog v-model="dialogDrawer" content-class="adv-dialog">
      <v-card class="content-bg--2">
        <div class="font-weight-bold display-1 pl-3 pr-2 pt-4 pb-3">
          {{ theme.name }}
          <div
            v-if="hotspotList && hotspotList.length"
            class="text--secondary subtitle-1 font-weight-medium mt-2"
          >
            {{ hotspotNames }}
          </div>
        </div>
        <v-divider></v-divider>
        <div class="pl-3 pr-4 py-3">
          <v-layout class="align-center">
            <div class="mr-4">
              <icon-pencil class="mr-4"></icon-pencil>
            </div>
            <v-layout class="justify-start ml-4">
              <v-btn
                :to="{ name: 'themeSettings', params: { id: theme.id } }"
                icon
                class="ma-0"
                left
              >
                <span class="ml-3">Изменить основные параметры</span>
              </v-btn>
            </v-layout>
          </v-layout>
          <div class="py-1">
            <icon-close class="mr-3"></icon-close>
            <v-btn @click="delTheme" icon>
              <span class="ml-3">Удалить тему</span>
            </v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import IconClose from "../icon/IconClose.vue";
import IconDots from "../icon/IconDots";
import IconPencil from "../icon/IconPencil.vue";
import ThemePreviewXs from "./ThemePreview.vue";

export default {
  name: "ThemeItem",

  components: {
    ThemePreviewXs,
    IconClose,
    IconDots,
    IconPencil
  },

  props: {
    // тема
    theme: {
      type: Object,
      required: true
    }
  },

  data: () => ({
    dialogDrawer: false
  }),

  mounted() {},

  computed: {
    // для мобильной версии
    isMobile() {
      return ["xs"].includes(this.$vuetify.breakpoint.name);
    },
    // список доступных хотспотов
    hotspotList() {
      let items;
      if (this.theme.hotspot_themes) {
        items = this.$store.getters.hotspotList.filter(item =>
          this.theme.hotspot_themes
            .map(hotspot_theme => hotspot_theme.hotspot_id)
            .includes(item.id)
        );
      }
      return items;
    },
    // список для отображения прикрепленных хотспотов
    hotspotNames() {
      let subtitle;
      let subtitlesList = this.hotspotList.map(item => {
        if (item.ssid_hotspot) return item.ssid_hotspot;
        return item.title;
      });
      switch (subtitlesList.length) {
        case 1:
          subtitle = subtitlesList[0];
          break;
        case 2:
          subtitle = subtitlesList[0] + " и " + subtitlesList[1];
          break;
        case 3:
          subtitle = subtitlesList.join(", ");
          break;
        default:
          subtitle =
            [...subtitlesList].splice(0, 2).join(", ") +
            ` и еще ${subtitlesList.length - 2}`;
      }
      return subtitle;
    }
  },

  methods: {
    /**
     * Дублирование темы
     */
    copyTheme() {
      let params = { ...this.theme };
      delete params.id;
      params.name += " (копия)";
      this.$store.dispatch("copyTheme", params).then(() => {
        // открываем сообщение
        this.$store.dispatch("popupInfoOpen", {
          text: "Тема успешно добавлена"
        });
      });
    },
    /**
     * Удаление темы
     */
    delTheme() {
      this.$store.dispatch("deleteTheme", { id: this.theme.id }).then(() => {
        // открываем сообщение
        this.$store.dispatch("popupInfoOpen", {
          text: "Тема успешно удалена",
          timeout: 180000,
          action: {
            name: "Восстановить",
            method: "recoveryTheme",
            textThen: "Тема успешно восстановлена",
            param: { id: this.theme.id }
          }
        });
      });
    },
    openDialog() {
      this.dialogDrawer = true;
    },
    closeDialog() {
      this.dialogDrawer = false;
    }
  }
};
</script>
